// Dependencies
require("section/information");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/information/index.js
 ** module id = 147
 ** module chunks = 0 1
 **/